import { pngVidaaSLogo } from 'assets/img'
import Button from 'components/Button'
import Loading from 'components/Loading'
import { FormEvent, useEffect, useState } from 'react'
import api from 'services/api'
import { clearMask } from 'utils/formatters'
import * as Style from './styles'

const VIDAAS_ID_TOKEN = '@CANNECT_VIDAAS_TOKEN'

type Expiration = 3600 | 7200 | 14400 | 28800 | 43200

type VidaasProps = {
  onSign: (success: boolean) => void
}

type FetchAuthorizationResponse = {
  code: string
}

type FetchAuthenticationResponse = {
  token: string
}

export default function VidaaS({ onSign }: VidaasProps) {
  const [expirationTime, setExpirationTime] = useState<Expiration>(3600)
  const [cpf, setCpf] = useState('')
  const [vidaasToken, setVidaasToken] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (localStorage.getItem('@CANNECT_SIGNED_USER')) {
      const connectedUser = JSON.parse(localStorage.getItem('@CANNECT_SIGNED_USER') as string)
      setCpf(connectedUser.cpf)
      handleSendNotification(connectedUser.cpf)
    }
  }, [])

  async function handleSignature(event?: FormEvent) {
    if (event) {
      event.preventDefault()
    }
    setLoading(true)
    try {
      const response = await api.post<FetchAuthenticationResponse>(`/signature_authentication`, {
        username: clearMask(cpf),
        password: vidaasToken,
        lifetime: expirationTime,
        provider: 'vidaas',
        qrcode: false
      })
      const tokenObject = {
        token: response.data.token,
        expiration: calculateExpiration()
      }
      localStorage.setItem(VIDAAS_ID_TOKEN, JSON.stringify(tokenObject))
      onSign(true)
    } catch (err) {
      console.error(err)
      onSign(false)
    }
    setLoading(false)
  }

  async function handleSendNotification(doctorCpf: string) {
    setLoading(true)
    try {
      const response = await api.post<FetchAuthorizationResponse>(`/recipe/signature/authorization`, {
        username: doctorCpf,
        provider: 'vidaas'
      })
      console.log(response)
      setVidaasToken(response.data.code.slice(5))
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  function calculateExpiration() {
    let currentDate = new Date().getTime()
    currentDate += expirationTime * 1000
    return currentDate
  }

  return (
    <Style.VidaasContainer onSubmit={(event) => handleSignature(event)}>
      <img src={pngVidaaSLogo} alt="VidaaS" />
      <h1>Validação de token</h1>
      <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
        <p>
          Abra o VIDaaS em seu dispositivo registrado para
          <br />
          autenticar o Token.
          <br />
          <br />
          Uma vez autenticado, clique no botão abaixo:
        </p>
      </div>
      <Button type="submit" style={{ marginTop: '2rem' }}>
        TOKEN VALIDADO NO MEU DISPOSITIVO
      </Button>
      {loading && <Loading loading={loading} />}
    </Style.VidaasContainer>
  )
}
